import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { userGroupUrlCheck} from '../../../utils/userGroupUrlCheck';
import { LOGIN_SUPER_ADMIN_GROUP, LOGIN_AFFILIATE_GROUP, LOGIN_CLIENT_GROUP, ROUTE_DASHBOARD, ROUTE_AFFILIATE_DASHBOARD, ROUTE_CLIENT_DASHBOARD, LOGIN_ROUTE_AFFILIATE, LOGIN_ROUTE_CLIENT } from '../../../configs/staticConfigs'; 
// import { URL_IMG } from '../../../configs/urlConfigs'; 
import { LBL_AFFILIATE, LBL_SELECT, LBL_SUBMIT, LBL_LOGIN_SA, LBL_LOGIN_AFFILIATE, LBL_LOGIN_CLIENT, LBL_USERNAME, LBL_PASSWORD, LBL_FORGOT_PASSWORD, LBL_LOGIN, LBL_CLOSE, LBL_RESET_YOUR_PASSWORD, LBL_FORGOT_YOUR_PASSWORD, LBL_CANCEL, LBL_SEND_PASSWORD_RESET_EMAIL, LBL_EMAIL, LBL_REMEBER_ME } from '../../../configs/labelConfigs';
// import { MSG_FORGOT_PWD_ERROR } from '../../../configs/msgConfigs';

import ModalWindow from '../../commons/helpers/modalWindow';
// import fetch from 'node-fetch';

class LoginView extends Component {

    constructor(props){
        super(props); 
        this.modalForgotPassword = React.createRef(); 
    }

    forgotPassword = (e,uGroup) => {
        this.props.resetForgotPwd(); 
        this.modalForgotPassword.current.handleOpenModal();
    }

    closeForgotPwd = (e) => {
        this.props.resetForgotPwd(); 
        this.modalForgotPassword.current.handleModelClose(); 
    }

    onModalFormReset = () =>{
        this.props.resetForgotPwd(); 
    }

    onSubmit = () => {
         
    } 
    
    resetModalForm = () => {
         
    }

    
    render(){
        const {location,defaultAffiliateId,arrAffiliates} = this.props; 
        let sel_affiliate = this.props.userData.sel_affiliate; 
        let affiliatesCount = 0;
        if(Array.isArray(arrAffiliates)) affiliatesCount = arrAffiliates.length; 
        let userGroupData = userGroupUrlCheck(location);
        let userGroupToken = '';
        let userGroup = '';
        if(userGroupData!==undefined){
            userGroupToken = userGroupData.accessToken;
            userGroup = userGroupData.user_group;
        }
        let btnClass = ' btn-primary '; 
        let pathName = this.props.location.pathname.toLowerCase();  
        if(this.props.location.pathname.indexOf(LOGIN_ROUTE_AFFILIATE) >=0) {
            btnClass = ' loginAffiliateButton '; 
        } 
        else if(this.props.location.pathname.indexOf(LOGIN_ROUTE_CLIENT) >=0) {
            btnClass = ' loginClientButton '; 
        }
        
        return(
                <React.Fragment>
                { ((userGroupToken !== null) && (userGroup===LOGIN_SUPER_ADMIN_GROUP)) ? <Redirect to={ROUTE_DASHBOARD} /> : ((userGroupToken !== null) && (userGroup===LOGIN_AFFILIATE_GROUP)) ? <Redirect to={ROUTE_AFFILIATE_DASHBOARD} /> : ((userGroupToken !== null) && (userGroup===LOGIN_CLIENT_GROUP) && defaultAffiliateId > 0) ? <Redirect to={ROUTE_CLIENT_DASHBOARD} />: null }
                <div className="loginHeader" > 
                    {(pathName==='/super' || pathName==='/super/') &&  <React.Fragment>
                        {/* <img src={require('../../../'+URL_IMG+'superadmin.jpg')} alt="Super Admin" title="Super Admin Login" className="groupTypeLogo" /> */}
                        <span title="Super Admin Login">&nbsp; {LBL_LOGIN_SA}</span>
                        </React.Fragment> }   
                
                    {(pathName==='/affiliate' || pathName==='/affiliate/') && <React.Fragment>
                        {/* <img src={require('../../../'+URL_IMG+'affiliate.jpg')} alt="Affiliate" title="Affiliate Login" className="groupTypeLogo" /> */}
                        <span title="Affiliate Login">&nbsp; {LBL_LOGIN_AFFILIATE}</span></React.Fragment> }  

                    {(pathName==='/client' || pathName==='/client/') && <React.Fragment>
                        {/* <img src={require('../../../'+URL_IMG+'client.jpg')} alt="Client" title="Client Login" className="groupTypeLogo" /> */}
                        <span title="Client Login">&nbsp; {LBL_LOGIN_CLIENT}</span></React.Fragment> }  

                </div>    
                <div className="login-box">
                    <div className="row"> 
                        <form className="col-md-12" onSubmit={this.props.handleLogin}>
                            <div>
                                <div className="form-group">
                                    <label>{LBL_USERNAME}</label>
                                    <div className={affiliatesCount > 0 ? "input password-input disabledElement" : "input password-input"}>
                                        <input name="txtUsername" type="text" placeholder="Username"  className={this.props.formErrors.txtUsername.length >0 ? "input-error" : '' }  onChange={this.props.handleChange} disabled={affiliatesCount > 0 ? true : false} value={this.props.userData.txtUsername?this.props.userData.txtUsername:''} />
                                    </div>
                                    {this.props.formErrors.txtUsername.length >0 && (
                                        <div className="text-red left-align text-12">{this.props.formErrors.txtUsername}</div>
                                    )}  
                                </div>
                            </div>
                            <div>
                                <div className="form-group"> 
                                    <label onClick={this.props.onRememberMe}>{LBL_PASSWORD}</label>
                                    <div className={affiliatesCount > 0 ? "input password-input disabledElement" : "input password-input"} >
                                        <input name="txtPassword" type="password" placeholder="Password" autoComplete="off" className={this.props.formErrors.txtPassword.length >0 ? "input-error" : '' }  onChange={this.props.handleChange} disabled={affiliatesCount > 0 ? true : false} value={this.props.userData.txtPassword?this.props.userData.txtPassword:''}  />
                                    </div>
                                    {this.props.formErrors.txtPassword.length >0 && (
                                        <div className="text-red left-align text-12">{this.props.formErrors.txtPassword}</div>
                                    )} 
                                </div>
                                <div className="form-group text-left text-red text-12">
                                    {(!this.props.isLoggedIn) && this.props.loginSubmitted > 0 && this.props.errorMessage } 
                                </div>
                            </div>
                            {(affiliatesCount===0) && <div> 
                                <div className="form-group">
                                {this.props.uGroup > 0 && <>
                                    <div className="float-left width200">
                                        
                                        <div className="remember-me-label"> <div className="custom-checkbox"><input type="checkbox" id="chk-remember" name="chk-remember" checked={this.props.rememberMe} onChange={this.props.onRememberMe} /> 
                                        <label className="checkbox" htmlFor="chk-remember" ></label> 
                                        </div><span onClick={this.props.onRememberMe}> {LBL_REMEBER_ME}</span></div>
                                    </div> 
                                    <div className="form-group text-right">
                                        <Link to="#" className="forgot-password" onClick={e => this.forgotPassword(e,this.props.uGroup)} >{LBL_FORGOT_PASSWORD}</Link>
                                    </div></>}
                                <button type="submit" className={"btn float-right "+btnClass} >{LBL_LOGIN}</button>
                                </div>
                            </div> }

                            {(affiliatesCount > 0) && (userGroup===LOGIN_CLIENT_GROUP) && 
                                <><div>
                                    <div className="form-group">
                                        <label>{LBL_SELECT+' '+LBL_AFFILIATE}</label>
                                        <div className="form-group select-input" style={{verticalAlign: "middle"}} >
                                            <select onChange={this.props.handleChange} name="sel_affiliate" value={sel_affiliate || ''} className={this.props.formErrors.sel_affiliate.length >0 ? "paddingTopBottom10 input-error" : 'paddingTopBottom10'} >
                                                {/* {(affiliatesCount===0 || affiliatesCount > 1) && <option value="">Select</option>} */}
                                                <option value="0">{LBL_SELECT}</option>
                                                {arrAffiliates.map((item) => <option key={item.company_id} value={item.company_id}>{item.company_name}</option>)}  
                                            </select> 
                                            {this.props.formErrors.sel_affiliate.length >0 && (
                                                <div className="text-red left-align text-12">{this.props.formErrors.sel_affiliate}</div> 
                                            )}  
                                        </div>    
                                    </div>
                                </div> 
                                <div>
                                    <div className="form-group">
                                    <button onClick={this.props.setAffiliate} className={"btn float-right "+btnClass} >{LBL_SUBMIT}</button>
                                    </div>
                                </div></>
                            } 
                            
                        </form>
                    </div>
                </div>

                <ModalWindow ref={this.modalForgotPassword} header={LBL_RESET_YOUR_PASSWORD} type="submit" onSubmit={this.onSubmit} resetModalForm={this.onModalFormReset} noFooterButtons="yes" > 
                    {/* <div className="login-box">
                        <div className="row"> 
                            <form className="col-md-12">
                                <div>
                                        <div className="form-group">
                                            <label  className="float-left">&nbsp;{LBL_USERNAME} </label> 
                                            <div className={'input password-input'}>
                                                <input type="text" placeholder={LBL_USERNAME} name="forgot_username"   className={this.props.forgot_username_error && this.props.formErrors.forgot_username_error.length >0 ? "input-error" : ''}  onChange={this.props.handleChange} />
                                            </div>
                                        </div>
                                </div>
                            </form>   
                        </div>
                    </div>  */}
                    
                    <div className="forgot-box col-md-12">
                        
                        <div className="row col-md-12"> 
                            <form className="col-md-12" >
                                <div>
                                    {this.props.forgot_password_resp_success==='' && <div className="text-12 text-left paddingBottom10">{LBL_FORGOT_YOUR_PASSWORD}</div>}
                                    <div className="form-group text-left">
                                        {this.props.forgot_password_resp_success!==''  && <div className="text-red left-align" > {this.props.forgot_password_resp_success} </div>}

                                        {this.props.forgot_password_resp_success==='' && <><label>{LBL_USERNAME +' ('+LBL_EMAIL+')'}</label>
                                        <div className="input password-input">
                                            <input type="text" placeholder={LBL_USERNAME} name="forgot_username"   className={this.props.forgot_username_error && this.props.forgot_username_error.length >0 ? "input-error" : ''}  onChange={this.props.handleChange} value={this.props.forgot_username && this.props.forgot_username.length ? this.props.forgot_username : ''} />
                                        </div></>}

                                    </div>
                                </div>  
                                <div> 
                                    <div className="form-group">

                                        {this.props.forgot_password_resp_error!=='' && (
                                                <><div className="text-red left-align">{this.props.forgot_password_resp_error}</div> 
                                                <div>&nbsp;</div></>
                                         )}  

                                         {this.props.forgot_password_resp_success==='' && <><button type="button" className="btn btn-primary float-right" onClick={(e) => this.props.handleForgotPassword(e)}>{LBL_SEND_PASSWORD_RESET_EMAIL}</button> &nbsp; &nbsp; <button type="button" className="btn btn-secondary float-right" onClick={e => this.closeForgotPwd(e)}>{LBL_CANCEL}</button>  </>}

                                         {this.props.forgot_password_resp_success!=='' && <button type="button" className="btn btn-primary float-right" onClick={e => this.closeForgotPwd(e)}>{LBL_CLOSE}</button>}  
                                         
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
               </ModalWindow>
            </React.Fragment>
        )
    }
}

export default LoginView;